import React from "react";
import { HistorySection } from "../HistorySection";
import { PageLoadingState } from "./PageLoadingState";
import { EmptyInvoiceState } from "./EmptyInvoiceState";

export const BillingHistoryTab = ({
  invoice,
  subscriptionStatus,
  currentPlanDetails,
  hasPlanId,
  companyId,
  handleInitiatePayment,
  setActiveTab,
}) => {
  const invoicesWithCompanyId = invoice.transactions.map((inv) => ({
    ...inv,
    companyId,
  }));

  return (
    <div className="space-y-6 animate-in slide-in-from-left-4 duration-300">
      {invoice.loadingTransactions ? (
        <PageLoadingState />
      ) : invoice.transactions.length === 0 ? (
        <EmptyInvoiceState />
      ) : (
        <HistorySection
          invoices={invoicesWithCompanyId}
          isLoading={invoice.loadingTransactions}
          subscriptionStatus={subscriptionStatus}
          selectedPlanDetails={currentPlanDetails}
          hasPlanId={hasPlanId}
          onChangePlan={() => setActiveTab("subscription-plans")}
          onPayInvoice={handleInitiatePayment}
        />
      )}
    </div>
  );
};
